import { type ViewMode, ViewModeOptions } from '@/features/types';

export function isInProjectUrl(currentViewMode: ViewMode): boolean {
  return (
    currentViewMode.mode === ViewModeOptions.CUSTOM_LIST_DETAIL ||
    currentViewMode.mode === ViewModeOptions.CUSTOM_LIST_SPAN
  );
}

export function addQueryParamToCurrentUrl(
  key: string,
  value: string | number | boolean,
  params: URLSearchParams
): string {
  params.set(key, String(value));
  const newUrl = `${window.location.pathname}?${params.toString()}`;

  return newUrl;
}
